import('../src/javascripts/attachments-redesign');
import('../src/javascripts/navigation');
import('../src/javascripts/smooth-scroll-to-anchor');
import('../src/javascripts/easy-toggle');
import('../src/javascripts/ai-maturity-report-form');
